let USERPILOT_IID: NodeJS.Timeout | number | null = null;
const k = 10;
const MAX_TRIES = 60 * k;

/**
 * Whait till userpilot is loaded with max tries
 * @param callback
 */
export function onUserPilotLoad(callback: () => void) {
  USERPILOT_IID && clearInterval(USERPILOT_IID);
  if (window['userpilot']) {
    callback();
  } else {
    let tries = MAX_TRIES;
    USERPILOT_IID = setInterval(() => {
      if (window['userpilot']) {
        callback();
        USERPILOT_IID && clearInterval(USERPILOT_IID);
      } else {
        tries--;
        if (tries <= 0) {
          USERPILOT_IID && clearInterval(USERPILOT_IID);
        }
      }
    }, 500 / k);
  }
}
